export default {
  path: 'invoices',
  name: 'invoices',
  component: () => import('../views/invoices/Invoices.vue'),
  meta: {
    layout: 'main',
    breadcrumb: {
      linkTo: 'invoices',
      linkText: 'Счета'
    }
  }
}